import { queryKeyPrefix } from 'src/features/tanStackQuery/queryKeyPrefix'

const prefix = queryKeyPrefix.placeGroups

export const placeGroupQueryKeys = {
  all: [...prefix, 'placeGroups'] as const,
  list: [...prefix, 'placeGroups', 'list'] as const,
  assignablePlaces: (
    targetGroupNodeUuid: string | undefined,
    placeName: string,
  ) =>
    [
      ...prefix,
      'assignablePlaces',
      { targetGroupNodeUuid, placeName },
    ] as const,
}
